const LOCK_NAME = "pj:token-refresh"

/**
 * Serialises refresh-token exchanges across tabs: the backend rotates the token on every use and
 * revokes the whole session when a spent one comes back. `refresh` must read the stored token
 * itself, so a tab that waited here uses the value the winner wrote.
 */
export const withRefreshLock = async <T>(
  refresh: () => T | Promise<T>,
): Promise<T> => {
  // No Web Locks while server-rendering, where there are no other tabs to race anyway.
  if (typeof navigator === "undefined" || !("locks" in navigator)) {
    return refresh()
  }

  return navigator.locks.request(LOCK_NAME, refresh)
}
